/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { ActivityLogSource } from 'cio/utils/activity-logs';

type FormattedLogSourceNewsletterLinkArgs = {
  source: ActivityLogSource;
};

export default class FormattedLogSourceNewsletterLink extends Component<FormattedLogSourceNewsletterLinkArgs> {
  get hasNewsletter() {
    return !isEmpty(this.args.source.newsletterName);
  }
}
